<template>
<div class="top_header">
  <div class="width_auto flexr justify_between align_center" style="position: relative">
    <div class="top_header_title flexr " @click="$router.push('/')"><p>能</p> <span>武汉光谷水资绿能投资有限公司</span> </div>
<!--    <img @click="$router.push('/')" src="@/assets/logo/logo.png" alt="logo" class="top_header_logo" />-->
    <ul class="top_header_menu flexr">
      <li><router-link to="/" :class="{'router-active':activeIndex=='/index'}">首页</router-link></li>
      <li v-for="(item,index) in tabList" :key="index">
        <router-link v-if="!item.children||item.children.length==0" :to="`${item.link}`" :class="{'router-active':isLastSegmentEqual(activeIndex,item.link)}">{{ item.navName }}</router-link>
        <el-dropdown v-else @command="handleCommand">
          <router-link  :to="`${item.link}`" :class="{'router-active':isLastSegmentEqual(activeIndex,item.link)}">{{ item.navName }}</router-link>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(child,ci) in item.children"  :key="ci" :command="`${child.navSkip}/${item.categoryId}/${child.categoryId}`">{{ child.navName }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </li>
    </ul>
    <div class="icon-top" @click="gotoPage">{{ !isLogin?'供应商登录':'供应商中心' }}</div>
<!--    <HeaderSearch id="header-search" class="icon-top"></HeaderSearch>-->
  </div>
</div>
</template>

<script>
// import HeaderSearch from "@/components/HeaderSearch";
import store from "@/store";
import {navbarList} from "@/api";

export default {
  name: "topHeader",
  components:{
    // HeaderSearch,
  },
  computed: {
    isLogin(){
      return store.state.isLogin
    }
  },
  data(){
    return {
      activeIndex:'Index',
      tabList:[]

    }
  },
  // computed: {
  //   idCategory(){
  //     return store.state.idCategory||{}
  //   },
  //   newsClassifyList(){
  //     return store.state.newsClassify||[]
  //   },
  //   noticeClassifyList(){
  //     return store.state.noticeClassify||[]
  //   },
  //   grupList(){
  //     return store.state.grupList||[]
  //   },
  //   hrList(){
  //     return store.state.hrList||[]
  //   },
  //   buildClassify(){
  //     return store.state.buildClassify||[]
  //   },
  // },

  watch:{
    $route(to, from){
      console.log(to.name)
      this.activeIndex = to.path
    }
  },

  mounted() {
    console.log(this.$route)
    this.activeIndex = this.$route.path
    this.getList()
    //新闻中心
    // store.dispatch('GetCategoryList',{parentId:this.idCategory.newsCP,type:'news'})
    // store.dispatch('GetCategoryList',{parentId:this.idCategory.noticeCP,type:'notice'})
    // store.dispatch('GetArticleList',{categoryId:this.idCategory.hrC,type:'hr'})
    // store.dispatch('GetArticleList',{categoryId:this.idCategory.groupC,type:'group'})
    // //党建纪检
    // store.dispatch('GetCategoryList',{parentId:this.idCategory.djjjCP,type:'partyBuilding'})
  },
  methods: {
    gotoPage(){
      this.$router.push('/supplierLogin')
    },
    isLastSegmentEqual(path1, path2) {
  // 获取最后一个斜杠前的部分
  const getLastSegment = (path) => {
    const segments = path.split('/');
    return segments.slice(0, -1).join('/');
  };
  console.log(getLastSegment(path1) ,'--0---', getLastSegment(path2))
  // 比较两个路径的最后斜杠前部分是否相同
  return getLastSegment(path1) === getLastSegment(path2);
},
getList(){
      navbarList().then(res=>{
        this.tabList = res.map(item=>{
          let link=item.navSkip+'/'+item.categoryId+'/'+0
          return {
            ...item,
            navSkip:item.navSkip,
            link:link
          }
        })
      })
    },
    handleCommand(command) {
      this.$router.push(command)
    }
  }
}
</script>

<style scoped lang="scss">
$top-header-height:72px;
::v-deep .el-dropdown-menu__item{
  font-size: 16px!important;
}
.top_header{
  height: $top-header-height;
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  .width_auto{
    height: 100%;
  }
  .top_header_logo{
    height: 40px;
    width: auto;
    cursor: pointer;
  }
  .top_header_menu{
    margin-right: 10px;
    li{
      margin:0 0px;
      a{

        line-height: 30px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #202021;
        display: inline-block;
        padding: 0 13px;
        height: 72px;
        line-height: 72px;
        &:hover{
          color: #255AA7;
        }
      }
      &:first-child{
        margin-left: 0;
      }
      &:last-child{
        margin-right: 0;
      }
    .router-active{
      position: relative;
      background:#255AA7;
      color: #fff!important;
      a{
        color: #fff!important;
      }
    }
    }
  }
}
.icon-top{
  position: absolute;
  right: -100px;
  width: 90px;
  height: 40px;
  background: #FFFFFF;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #BEBEBE;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #202021;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  &:hover{
    background: #255AA7;
    color: #fff;
  }
}

.el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover{
  background-color: #2c89f1!important;
  color: #fff!important;
}

.top_header_title{
  cursor: pointer;
p{
  width: 44px;
  height: 44px;
  background: #255AA7;
  border-radius: 50%;
  text-align: center;
  line-height: 50px;
  color: #fff;
  font-size: 30px;
  font-weight: bold;
  margin-right: 10px;
}
  span{
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 20px;
    color: #255AA7;
    line-height: 32px;
  }

}
</style>
